import {
    GET_LIST,
    GET_ONE,
    GET_MANY,
    GET_MANY_REFERENCE,
    CREATE,
    UPDATE,
    DELETE,
    fetchUtils,
} from 'admin-on-rest';
import { stringify } from 'query-string';

import { API_BASE_URL as API_URL} from './endpoints'

/**
 * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
 * @param {String} resource Name of the resource to fetch, e.g. 'posts'
 * @param {Object} params The REST request params, depending on the type
 * @returns {Object} { url, options } The HTTP request parameters
 */
const convertRESTRequestToHTTP = (type, resource, params) => {
    let url = '';
    const options = {};
		
    switch (type) {
    case GET_LIST: {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        const query = {
            sort: JSON.stringify([field, order]),
            range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),           	
        };		
		
		//add initial_ filters as direct getqueries to url, otherwise request is done double (1 without filters, one with) due to design of AOR
		var initialfilters = [];
		var inputs = document.getElementsByTagName("input");
		for(var i = 0; i < inputs.length; i++) {
			if(inputs[i].name.indexOf('initialfilter_') === 0) {
				initialfilters.push(inputs[i]);
			}
		}
		
		//every input that starts with initialfilter_, transform to a real filter (without the initalfilter_ prefix) and optional per attribute transformations
		//if attribtue is lready in default params.filter attributes then no custom processing
		for(var i=0;i<initialfilters.length;i++) {
			var input = initialfilters[i];
			var attribute_full = input.name;
			var attribute = input.name.substring(14,input.name.length); //cut inital from name
			if(typeof params.filter[attribute_full] === 'undefined') {
				//filter not already set in params
				if(attribute == 'from_date') {
					//transform from date to UTC
					var value = input.value;
					var parts =value.split('-');	
					var day=parts[0];
					var month=parts[1]-1;					
					var year=parts[2];	
					var transformedDate = new Date(year,month, day).toISOString();
					params.filter[attribute] = transformedDate;					
				}
			} else {
				params.filter[attribute] = params.filter[attribute_full];	
			}
		}
		
		//default filters transformed to direct get params
		for (var attrname in params.filter) { 			
			query[attrname] = params.filter[attrname] 
		}; 
		
		options.method = 'GET';
        url = `${API_URL}/${resource}?${stringify(query)}`;
        break;
    }
    case GET_ONE:
		var resource_use = resource;
		if(resource == "admin/siteclick_blacklisted" || resource == "admin/siteclick_blacklisted_startswith" || resource == "admin/siteclick_blacklisted_ai" || resource == "siteclick_filtered_doubles") { resource_use = "admin/siteclick"; }
        options.method = 'GET';
        url = `${API_URL}/${resource_use}/${params.id}`;
        break;
		
    case GET_MANY: {
		options.method = 'GET';
        const query = {
            filter: JSON.stringify({ id: params.ids }),
        };
        url = `${API_URL}/${resource}?${stringify(query)}`;
        break;
    }
    case GET_MANY_REFERENCE: {
		options.method = 'GET';
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        const query = {
            sort: JSON.stringify([field, order]),
            range: JSON.stringify([(page - 1) * perPage, (page * perPage) - 1]),
            filter: JSON.stringify({ ...params.filter, [params.target]: params.id }),
        };
        url = `${API_URL}/${resource}?${stringify(query)}`;
        break;
    }
    case UPDATE:
        var resource_use = resource;
		if(resource == "admin/siteclick_blacklisted" || resource == "admin/siteclick_blacklisted_startswith" || resource == "admin/siteclick_blacklisted_ai" || resource == "siteclick_filtered_doubles") { resource_use = "admin/siteclick"; }
        
		url = `${API_URL}/${resource_use}/${params.id}`;
        options.method = 'PUT';
        options.body = JSON.stringify(params.data);
        break;
	case 'POST':
    case CREATE:
        url = `${API_URL}/${resource}`;
        options.method = 'POST';
        options.body = JSON.stringify(params.data);
        break;
    case DELETE:
		var resource_use = resource;
		if(resource == "admin/siteclick_blacklisted" || resource == "admin/siteclick_blacklisted_startswith" || resource == "admin/siteclick_blacklisted_ai" || resource == "siteclick_filtered_doubles") { resource_use = "admin/siteclick"; }
        url = `${API_URL}/${resource_use}/${params.id}`;
        options.method = 'DELETE';
        break;
	case 'DELETE_ALL':
        url = `${API_URL}/${resource}`;
        options.method = 'DELETE';
        options.body = JSON.stringify(params.data);
        break;
    default:
        throw new Error(`Unsupported fetch action type ${type}`);
    }
    return { url, options };
};

/**
 * @param {Object} response HTTP response from fetch()
 * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
 * @param {String} resource Name of the resource to fetch, e.g. 'posts'
 * @param {Object} params The REST request params, depending on the type
 * @returns {Object} REST response
 */
const convertHTTPResponseToREST = (response, type, resource, params) => {
    const { headers, json } = response;
    
	if(response.status && (response.status == 401 || response.status == 403)) {
		 localStorage.removeItem('token');
         return Promise.reject();
	}
	
	switch (type) {
		case GET_LIST:
			/* onze Cloudints API geeft nog geen content-range header terug, todo       
		   return {
				data: json.map(x => x),
				total: parseInt(headers.get('content-range').split('/').pop(), 10),
			};
			*/
			//response is object
			if(params.response_single)  return { data: json };
			
			//response is list
			return {
				data: json.map(x => x),
				total: parseInt(headers.get('content-range')),
				aggregates: headers.get('aggregates'),
			};
		case CREATE:
			return { data: { ...params.data, id: json.id } };
	
		case GET_ONE:
			return { data: json };
		
		case DELETE:
			return { data: {} };
	
		case UPDATE:
			return { data: json };
	   
		default:
			return { data: json };
    }
};

/**
 * @param {string} type Request type, e.g GET_LIST
 * @param {string} resource Resource name, e.g. "posts"
 * @param {Object} payload Request parameters. Depends on the request type
 * @returns {Promise} the Promise for a REST response
 */
export default (type, resource, params) => {
    const { fetchJson } = fetchUtils;
    const { url, options } = convertRESTRequestToHTTP(type, resource, params);
	
		const token = localStorage.getItem('token');
		if (token && token != 'undefined' && typeof token !== 'undefined') {
			options.headers = new Headers();
			options.headers.set('Authorization', `Bearer ${token}`);
		}
		
		
	
    return fetchJson(url, options)
        .then(response => convertHTTPResponseToREST(response, type, resource, params));
};


// WEBPACK FOOTER //
// ./src/restClient.js